export const IMPERSONATOR_BACKUP_KEY =
  "ember_admin_token_impersonator_backup";
export const IMPERSONATING_LABEL_KEY = "ember_admin_impersonating_label";

export function isAdminImpersonating(
  storage: Pick<Storage, "getItem"> | undefined = typeof localStorage ===
  "undefined"
    ? undefined
    : localStorage,
): boolean {
  return Boolean(storage?.getItem(IMPERSONATOR_BACKUP_KEY));
}

export function clearAdminImpersonationSession(
  storage: Pick<Storage, "removeItem"> | undefined = typeof localStorage ===
  "undefined"
    ? undefined
    : localStorage,
): void {
  storage?.removeItem(IMPERSONATOR_BACKUP_KEY);
  storage?.removeItem(IMPERSONATING_LABEL_KEY);
}
